var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('pageTop'),(_vm.isMobile())?_c('MobileHome'):_c('PcHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }